import { AlertEnum, ButtonVariantEnum, TipoMembroComissaoEnum } from '../../enums';
import { useAlert, useAuthAxios, useErrorHandler, useModal } from '../../hooks';

import { ApiHelper } from '../../helpers';
import { ComissaoEleitoralMembrosListType } from '../../types';
import { FaTrashAlt } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import { IconButton } from '../../components';
import { useTranslation } from 'react-i18next';

const ComissaoEleitoralMembrosList: FunctionComponent<ComissaoEleitoralMembrosListType> = ({
  membrosComissao,
  idEleicao,
  alteracao = false,
  setMembrosComissao,
}) => {
  const { t } = useTranslation();
  const errorHandler = useErrorHandler();
  const { createAlert } = useAlert();
  const axios = useAuthAxios();
  const { confirmModal } = useModal();

  return (
    <ul className="list-group">
      {membrosComissao?.map((membro) => (
        <li className="list-group-item" key={membro.id}>
          <div className="d-flex justify-content-between">
            <div className="d-flex row justify-content-start col-md-11 col-10">
              <div className="col">{membro.identificador}</div>
              <div className="col-lg-9">{membro.nome}</div>
            </div>
            <div className="justify-content-end align-items-center d-flex">
              {membro.tipo_membro === TipoMembroComissaoEnum.PRESIDENTE ? (
                <span className="badge bg-warning-600 end-0">{t('label.presidente')}</span>
              ) : (
                alteracao &&
                setMembrosComissao && (
                  <IconButton
                    Icon={FaTrashAlt}
                    title={t('label.remover_membro_comissao')}
                    variant={ButtonVariantEnum.DANGER}
                    onClick={() => {
                      confirmModal(
                        t('confirmacao.remover_membro_comissao', { nome_membro: membro.nome }),
                        () => {
                          setTimeout(() => {
                            axios(ApiHelper.getUrl.apiSCE.membroComissao(idEleicao, membro.id), {
                              method: 'DELETE',
                            })
                              .then((response) => {
                                createAlert(t('sucesso.remover_membro_comissao'), AlertEnum.SUCCESS);
                                setMembrosComissao(membrosComissao.filter((value) => value.id !== membro.id));
                              })
                              .catch((error) => errorHandler(error, t('erro.remover_membro_comissao')));
                          }, 400);
                        },
                        ButtonVariantEnum.DANGER,
                        t('label.remover_membro_comissao'),
                      );
                    }}
                  />
                )
              )}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ComissaoEleitoralMembrosList;
